class AnnouncementDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.triggers = document.querySelectorAll('.js-open-announcement-drawer');
  }

  connectedCallback() {
    // Register the click event on the trigger.
    this.triggers.forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.open(this.trigger);
      });
    });

    // This adds extra space to the bottom of the body so that mobile users can see the footer links.
    const spacerElement = document.createElement('div');
    spacerElement.classList.add('mobile-only');
    spacerElement.style.height = '72px';
    spacerElement.innerHTML = '&nbsp;';
    document.body.appendChild(spacerElement);
  }

  open(triggeredBy) {
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('AnnouncementDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
  }
}

if (!customElements.get('announcement-drawer')) {
  customElements.define('announcement-drawer', AnnouncementDrawer);
}